$(".team-popup__trigger").on("click", function(e) {
  e.preventDefault();

  const nome = $(this)
    .data("nome");

  const ruolo = $(this)
    .data("ruolo");

  const image = $(this)
    .data("image");

  const descrizione = $(this)
    .data("descrizione");

  $(".o-popup--team")
    .find(".o-team-popup__nome")
    .text(nome);

  $(".o-popup--team")
    .find(".o-team-popup__ruolo")
    .text(ruolo);

  $(".o-popup--team")
    .find(".o-team-popup__image")
    .html(image);

  $(".o-popup--team")
    .find(".o-team-popup__descrizione")
    .html(descrizione);

  $(".backplate").addClass("backplate--open");
  $(".o-popup--team").addClass("o-popup--open");


  /*set height popup*/
  var height = $('.o-team-popup__image img').height();
  if($(window).width() > 767) {
    $('.o-popup__body__inner').height(height);
    $('.o-popup__body__inner>div').innerHeight(height);
  }



});

$(".backplate,.o-popup__close").on("click", function() {
  $(".o-popup--team").removeClass("o-popup--open");
  $(".backplate").removeClass("backplate--open");
});